define(
        'commons/tap-tests-editor',['jquery', 'commons/loading-mask', 'commons/message-manager'],
        function($, LoadingMask, messages) {

            var TapTestsEditor = function(groupId, container, severities, isRoot) {
                this.mask = new LoadingMask('#tests');

                this.baseUrl = "/group/" + groupId + "/tests/frag/update";
                this.groupId = groupId;
                this.isRoot = isRoot;

                this.editRow = $('<tr></tr>');
                this.editRow.append('<td id="test-id"></td>');
                if (this.isRoot) {
                    this.editRow.append('<td><input id="test-name" name="name" type="text" style="width: 100%;" /></td>');
                } else {
                    this.editRow.append('<td id="test-name"/></td>');
                }
                var select = '<td><select id="test-severity" name="severity">';
                for (var i = 0; i < severities.length; i++) {
                    select += '<option value="' + severities[i] + '">' + severities[i] + '</option>';
                }
                select += '</select></td>';
                this.editRow.append(select);
                this.editRow.append('<td><a href="javascript:void(0);" class="edit"><span class="icon-ok icon-large"></span></a></td>');

                // bind ok
                this.editRow.find('.edit').click($.proxy(function(ev) {
                    var id = this.editRow.data('id');
                    var name;
                    if (this.isRoot) {
                        name = this.editRow.find('input#test-name').val();
                    } else {
                        name = this.editRow.data('name');
                    }
                    var severity = this.editRow.find('select#test-severity').val();
                    if (!this._verifyFields(id, name, severity)) {
                        return;
                    }
                    this.ajaxRequest({
                        key: id,
                        id: this.groupId,
                        name: name,
                        severity: severity,
                        action: 'edit'
                    }, function(data) {
                        // detach edit row
                        this.editRow.detach();
                        this.editRow.data('editing', false);
                        this._onSuccess(data);
                    }, function() {
                        this._onComplete();
                    });
                }, this));

                this.container = $(container);

                this._bind();
            };

            TapTestsEditor.prototype._bind = function() {
                $('.test-delete').click($.proxy(this._onDelete, this));
                $('.tr-select').click($.proxy(this._onSelect, this));
                $('.test-add').click($.proxy(this._onAdd, this));
            };

            TapTestsEditor.prototype._onDelete = function(ev) {
                var tr = $(ev.currentTarget).parent().parent();
                var id = tr.find('td.test-id').text();
                if (this.isRoot && confirm('Are you sure you want to delete the test ' + id + ' ?')) {
                    this.ajaxRequest({
                        key: id,
                        id: this.groupId,
                        action: 'delete'
                    }, function(data) {
                        this._onSuccess(data);
                    }, function() {
                        this._onComplete();
                    })
                    ;
                }
                ev.stopImmediatePropagation();
            };

            TapTestsEditor.prototype._onSelect = function(ev) {
                var tr = $(ev.currentTarget);
                var id = tr.find('.test-id').text();
                if (this.editRow.data('editing')) {
                    return;
                }
                this.editRow.data('editing', true);
                // fill edit row
                this.editRow.data('id', id);
                this.editRow.find('td#test-id').text(id);
                if (this.isRoot) {
                    this.editRow.find('input#test-name').val(tr.find('td.test-name').text());
                } else {
                    var name = tr.find('.test-name').text();
                    this.editRow.data('name', name);
                    this.editRow.find('td#test-name').text(name);
                }
                this.editRow.find('select option[value="' + tr.find('td.test-severity').text() + '"]').prop('selected', true);
                // attach row and remove tr
                tr.after(this.editRow);
                tr.remove();
            };

            TapTestsEditor.prototype._onAdd = function(ev) {
                if (this.isRoot) {
                    var tr = $(ev.currentTarget).parent().parent();
                    var id = tr.find('input#test-id').val();
                    var name = tr.find('input#test-name').val();
                    var severity = tr.find('select#test-severity').val();
                    if (!this._verifyFields(id, name, severity)) {
                        return;
                    }
                    this.ajaxRequest({
                        key: id,
                        id: this.groupId,
                        name: name,
                        severity: severity,
                        action: 'add'
                    }, function(data) {
                        this._onSuccess(data);
                    }, function() {
                        this._onComplete();
                    });
                }
            };

            TapTestsEditor.prototype._verifyFields = function(id, name, severity) {
                if (!id || id.length === 0) {
                    messages.error('Id must not be blank.');
                    return false;
                }
                id = id.trim();
                if (/^(?=.*[\s\.].*).*$/.test(id)) {
                    messages.error('Id ' + id + ' must not have white spaces or dot.');
                    return false;
                }
                if (!name || name.length === 0) {
                    messages.error('Name must not be blank.');
                    return false;
                }
                if (!severity || severity.length === 0) {
                    messages.error('Severity is mandatory.');
                    return false;
                }
                return true;
            };

            TapTestsEditor.prototype._onSuccess = function(data) {
                var error = $(data).filter('#error');
                if (error.length == 0) {
                    this.container.html(data);
                    this._bind();
                // If an error has been raised, do not refresh data in the container
                // and display the error message
                } else {
                    messages.error(error.text());
                }
            };

            TapTestsEditor.prototype._onComplete = function() {
                this.mask.hide();
            };

            TapTestsEditor.prototype.ajaxRequest = function(data, sucessFn, completeFn) {
                this.mask.show();
                $.ajax({
                    url: this.baseUrl,
                    type: 'POST',
                    dataType: 'html',
                    traditional: true,
                    context: this,
                    data: data,
                    success: sucessFn,
                    complete: completeFn
                });
            };
            return TapTestsEditor;
        });
